module.exports = __webpack_public_path__ + "static/media/tick.e0233ee2.svg";